import { Box, HStack, Text } from '@chakra-ui/react';
import { useMapCursorPosition } from '@hooks/useMapCursorPosition';
import { formatCoordinatesToString } from '@utils/validation/coordinates.utils';
import DmsCoordinates from 'dms-conversion';
import { FormattedMessage } from 'react-intl';

import { CoordinatesUnit } from '@/types/commons/commons.types';

interface CursorPositionTooltipProps {
  unit: CoordinatesUnit;
}

export function CursorPositionTooltip({ unit }: Readonly<CursorPositionTooltipProps>) {
  const { cursorPosition } = useMapCursorPosition();

  if (!cursorPosition?.lngLat.latitude || !cursorPosition.lngLat.longitude) {
    return null;
  }

  const dmsCoordinates = new DmsCoordinates(cursorPosition.lngLat.latitude, cursorPosition.lngLat.longitude);
  return (
    <Box
      position="absolute"
      left={cursorPosition.point.x}
      top={cursorPosition.point.y}
      pointerEvents="none"
      alignItems="flex-start"
      backgroundColor="neutral.black"
      padding={1}
      transform="translate(20px, -50%)"
    >
      <HStack alignItems="flex-start">
        <Text fontSize="md" color="neutral.300">
          <FormattedMessage id="controls.toolMenu.latLong" />
        </Text>
        <Text fontSize="md">{formatCoordinatesToString(dmsCoordinates, unit)}</Text>
      </HStack>
    </Box>
  );
}
